module.exports = __webpack_public_path__ + "img/DataAssertselect.7c853ce9.svg";